import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom'

import analyticsService from './services/AnalyticsService'
import constructorService from './services/ConstructorService'

import PageRenderer from './components/PageRenderer'
import MainLayout from './components/MainLayout'
import Loading from './components/Loading'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

function App() {

  const [website, setWebsite] = useState(undefined)

  useEffect(() => {
    analyticsService.initialize()
    
    const fetchData = async () => {
      try {
        // const website = await constructorService.fetchWebsiteFromApi()
        const website = {
              "id": 5,
              "name": "Agência BlackStar",
              "domain": "agenciablackstar.com.br",
              "pages": [
                  {
                      "id": 5,
                      "website_id": 5,
                      "title": "Página Inicial",
                      "name": "Página Inicial",
                      "path": "/",
                      "menu": 1,
                      "menu_order": 1,
                      "components": [
                          {
                              "id": 5,
                              "page_id": 5,
                              "name": "Text",
                              "size": 12,
                              "sort": 1,
                              "elements": {
                                  "line": 1,
                                  "content": {
                                      "5": {
                                          "id": 5,
                                          "component_id": 5,
                                          "type": "text",
                                          "size": "12",
                                          "content": "Black Star",
                                          "component_parent": null,
                                          "sort": 1
                                      }
                                  }
                              }
                          }
                      ]
                  }
              ]
          }
        setWebsite(website)
      } catch (error) {
        console.error('Erro ao fazer conexão com a API:', error.message)

        try {
          const website = constructorService.fetchWebsiteFromCache()
          if (!website) {
            throw new Error('Nenhum cache encontrado')
          }

          console.warn('Usando dados do cache para construção do site')
          setWebsite(website)
        } catch (error) {
          console.error('Erro ao carregar o site: ', error.message)
          setWebsite({ error: true })
        }
      }
    }
    fetchData()
  }, [])

  if (website === undefined) {
    return <Loading />
  }

  return (
    <Router>
      <Routes>
        <Route element={<MainLayout />}>
          {website.pages.map((page) => (
            <Route key={page.path} path={page.path} element={<PageRenderer page={page} />} />
          ))}
        </Route>
      </Routes>
    </Router>
  )


  // const routes = [
  //   {
  //     path: '/',
  //     component: <Home />
  //   }
  // ]

  // useEffect(() => {
  //   AnalyticsService.initialize();
  // })

  // return (
  //   <Router>
  //     <Routes>
  //       <Route element={<DefaultLayout />}>
  //         {routes.map((route) => (
  //           <Route key={route.path} path={route.path} element={route.component} />
  //         ))}
  //       </Route>
  //     </Routes>
  //   </Router>
  // );
}

// function DefaultLayout() {
//   return (
//     <>
//       <Header />
//         <main>
//           <Outlet />
//         </main>
//       <Footer />
//     </>
//   )
// }

export default App